/** dryRun với id không tồn tại. Fail-closed ồn ào thay vì im lặng trả rỗng. */
export class UnknownAlertError extends Error {
}
/** dryRun khi manager chưa thấy tick nào (chưa có bars để đánh giá). */
export class NoTickDataError extends Error {
}
